import Swal from "sweetalert2";
import { IUsuarios, IUsuariosPaginado } from "../interfaces/IUsuarios";
import api from './Api';

class UsuariosService {
    async obterTodos(funcaoSucesso?: (data: IUsuarios[]) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IUsuarios[]>('Usuario');
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async obterTodosPorClienteID(clienteID: number, funcaoSucesso?: (data: IUsuarios[]) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IUsuarios[]>('Usuario/BuscarPorClienteID/'+clienteID);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async obterPorId(id: number, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IUsuarios>(`Usuario/${id}`);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async criar(usuario: IUsuarios, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.post('Usuario', usuario);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async atualizar(usuario: IUsuarios, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.put(`Usuario/${usuario.id}`, usuario);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            await api.delete(`Usuario/${id}`);
    
            funcaoSucesso && funcaoSucesso();
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async bloquear(id: number, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.put(`Usuario/Bloquear/${id}`);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async desbloquear(id: number, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.put(`Usuario/Desbloquear/${id}`);

            funcaoSucesso && funcaoSucesso(result);

            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });

            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });

            return false;
        }
    }

    async listar(params: { page?: number; perPage?: number; q?: string; ativo?: boolean | null; clienteId?: number }): Promise<IUsuariosPaginado | null> {
        try {
            const query = new URLSearchParams();
            if (params.page) query.append('page', String(params.page));
            if (params.perPage) query.append('perPage', String(params.perPage));
            if (params.q) query.append('q', params.q);
            if (params.ativo !== null && params.ativo !== undefined) query.append('ativo', String(params.ativo));
            if (params.clienteId) query.append('clienteId', String(params.clienteId));

            const { data } = await api.get<IUsuariosPaginado>(`Usuario/listar?${query.toString()}`);
            return data;
        } catch (error: any) {
            Swal.fire({
                text: error.response?.data?.message || error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
            return null;
        }
    }

    async ativar(id: number, funcaoSucesso?: () => void): Promise<boolean> {
        try {
            await api.patch(`Usuario/${id}/ativar`);
            funcaoSucesso && funcaoSucesso();
            Swal.fire({ text: 'Usuário ativado com sucesso', timer: 3000, icon: 'success', showConfirmButton: false });
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.response?.data?.message || error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
            return false;
        }
    }

    async inativar(id: number, funcaoSucesso?: () => void): Promise<boolean> {
        try {
            await api.patch(`Usuario/${id}/inativar`);
            funcaoSucesso && funcaoSucesso();
            Swal.fire({ text: 'Usuário inativado com sucesso', timer: 3000, icon: 'success', showConfirmButton: false });
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.response?.data?.message || error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
            return false;
        }
    }
}


export default new UsuariosService();